import { render, staticRenderFns } from "./ReserveQuantityFirst.vue?vue&type=template&id=97ee0d4a&"
import script from "./ReserveQuantityFirst.vue?vue&type=script&lang=ts&"
export * from "./ReserveQuantityFirst.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports